import { TranslateService } from '@ngx-translate/core';
import { FilterGroup } from '@custom-components/general/table-filter-bar';
import { INSTALLATION_STATES, INSTALLATION_STATE_LABEL_KEYS } from '@core/constants';
import { InstallationStateEnum } from '@core/models';
import { DeviceStore } from '@root/app/store/device.store';

export function deviceTypeFilterGroup(
  deviceStore: InstanceType<typeof DeviceStore>,
  translate: TranslateService,
): FilterGroup {
  return {
    key: 'deviceType',
    label: translate.instant('devices.filter.deviceType.title'),
    options: deviceStore.deviceTypes()?.['device-types']?.map(dt => dt.description) ?? [],
  };
}

/** Installation state (RDT-1565): Installed, To be installed, Installation failed. Replaces the
 * old `provisioning` filter on the installation stages, which would otherwise AND with this one. */
export function installationStateFilterGroup(translate: TranslateService): FilterGroup {
  return {
    key: 'installationState',
    label: translate.instant('devices.filter.installationState.title'),
    options: INSTALLATION_STATES,
    optionLabels: Object.fromEntries(
      INSTALLATION_STATES.map(state => [
        state,
        translate.instant(INSTALLATION_STATE_LABEL_KEYS[state as InstallationStateEnum]),
      ]),
    ),
  };
}
